import { BasePodcastEditRouteStore } from "administration/podcast/stores";

class PodcastGroupEditRouteStore extends BasePodcastEditRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }

    async createPodcastGroup(resource) {
        const response = await this.service.createGroup(resource);
        return response.data;
    }

    async getPodcastGroup(id) {
        const response = await this.service.get(id, {
            embed: "subPodcasts,subPodcasts.podcastFeed,subPodcasts.genres,subPodcasts.location,subPodcasts.podcastCategory,subPodcasts.language,subPodcasts.producer,podcastCategory",
        });
        return response.data;
    }

    async updatePodcastGroup(resource) {
        const response = await this.service.updateGroup(resource);
        return response.data;
    }
}

export default PodcastGroupEditRouteStore;
